import React from "react";

import { useOrgModParams } from "src/features/orgmod";
import { PatientList as BasicHealthPatientList } from "src/modules/basic-health";
import { PatientList as HtxPatientList } from "src/modules/htx";
import { PatientList as KdPatientList } from "src/modules/kd";
import { PatientList as KtxPatientList } from "src/modules/ktx";
import { PatientList as LtxPatientList } from "src/modules/ltx";

export const PatientList: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "htx" || mod === "htx_nm") {
		return <HtxPatientList />;
	}
	if (mod === "ktx") {
		return <KtxPatientList />;
	}
	if (mod === "kd") {
		return <KdPatientList />;
	}
	if (mod === "basic_health") {
		return <BasicHealthPatientList />;
	}
	if (mod === "ltx") {
		return <LtxPatientList />;
	}
	return null;
};
